import "react-vertical-timeline-component/style.min.css";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import { Container } from "react-bootstrap";
import { FaSchool } from "react-icons/fa";
import React from "react";
import School from "./School.png";

const Education = () => {
  return (
    <Container id="education" fluid className="skill-card">
      <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
        <strong className="purple">Timeline</strong>
      </h1>
      <VerticalTimeline>
        <VerticalTimelineElement
          date={"December 2022 - November 2023"}
          contentStyle={{
            boxShadow: `var(--shadow)`,
            border: "3px solid var(--clr-primary)",
            borderRadius: "15px",
            backgroundColor: `var(--clr-bg)`,
            textAlign: "center",
            color: `var(--clr-fg-alt)`,
          }}
          contentArrowStyle={{
            borderRight: "16px solid  var(--clr-primary)",
          }}
          iconStyle={{
            border: ` 3px solid var(--clr-primary)`,
            backgroundColor: `var(--clr-bg)`,
            color: `var(--clr-primary)`,
          }}
          icon={<FaSchool />}
        >
          <h3 className="vertical-timeline-element-title" data-aos="fade-right">
            Software Developer Engineer - I (Full Stack)
          </h3>
          <h4
            className="vertical-timeline-element-subtitle"
            data-aos="fade-right"
          >
            Codeacious Technologies Pvt. Ltd.
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          date={"May 2021 - December 2022"}
          contentStyle={{
            boxShadow: `var(--shadow)`,
            border: "3px solid var(--clr-primary)",
            borderRadius: "15px",
            backgroundColor: `var(--clr-bg)`,
            textAlign: "center",
            color: `var(--clr-fg-alt)`,
          }}
          contentArrowStyle={{
            borderRight: "16px solid  var(--clr-primary)",
          }}
          iconStyle={{
            border: ` 3px solid var(--clr-primary)`,
            backgroundColor: `var(--clr-bg)`,
            color: `var(--clr-primary)`,
          }}
          icon={<FaSchool />}
        >
          <h3 className="vertical-timeline-element-title" data-aos="fade-right">
            Student
          </h3>
          <h4
            className="vertical-timeline-element-subtitle"
            data-aos="fade-right"
          >
            Masai School (Remote)
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date={"2018 - 2021"}
          contentStyle={{
            boxShadow: `var(--shadow)`,
            borderRadius: "15px",
            border: "3px solid var(--clr-primary)",
            backgroundColor: `var(--clr-bg)`,
            textAlign: "center",
            color: `var(--clr-fg-alt)`,
          }}
          contentArrowStyle={{
            borderRight: "16px solid  var(--clr-primary)",
          }}
          iconStyle={{
            border: ` 3px solid var(--clr-primary)`,
            backgroundColor: `var(--clr-bg)`,
            color: `var(--clr-primary)`,
          }}
          icon={<FaSchool />}
        >
          <h3 className="vertical-timeline-element-title" data-aos="fade-right">
            B.E (Bachlor of Engineering) Computer Science
          </h3>
          <h4
            className="vertical-timeline-element-subtitle"
            data-aos="fade-right"
          >
            Dr. Babasaheb Ambedkar Marathwada University Aurangabad,
            Maharashtra, India
          </h4>
          <p data-aos="fade-right"></p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </Container>
  );
};

export default Education;
